import { Component, Input, OnInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { Attachment } from '../../../models/attachment';
import { AttachmentService } from '../../../services/attachment.service';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
})
export class ImageComponent implements OnInit, OnChanges {

  @ViewChild('imagePreviewModal') imagePreviewModal: IonModal;

  @Input() image: Attachment;
  presignedUrl: string;
  imageLoadFailed = false;

  @Input() width: string;
  @Input() maxWidth: string = '100%';
  @Input() height: string;
  @Input() maxHeight: string = '100%';

  @Input() allowPreview: boolean = true;

  constructor(private attachmentService: AttachmentService) { }

  ngOnInit() {
    this.fetchPresignedUrl();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.image?.currentValue?.id !== changes.image?.previousValue?.id) {
      this.fetchPresignedUrl();
    }
  }

  private fetchPresignedUrl() {
    this.imageLoadFailed = false;
    this.presignedUrl = null;
    if (this.image?.id) {
      this.attachmentService.getPresignedUrl(this.image.id).subscribe(url => {
        this.presignedUrl = url;
      });
    }
  }

  onImageError(): void {
    this.imageLoadFailed = true;
  }

  launchPreviewModal() {
    if (this.allowPreview !== true) { return; }
    return this.imagePreviewModal?.present();
  }

}
